import { SITE_NAME } from '../config/site';
import { getWhatsAppUrl as staticWhatsAppUrl } from '../config/contact';

const API_BASE = process.env.REACT_APP_API_URL ?? '';
const PUBLIC_URL = process.env.PUBLIC_URL ?? '';

if (!API_BASE) {
  console.error('REACT_APP_API_URL NOT DEFINED!!!!');
}

export function resolveMediaUrl(url) {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/uploads/') && API_BASE) {
    return `${API_BASE.replace(/\/$/, '')}${url}`;
  }
  if (url.startsWith('/')) {
    return `${PUBLIC_URL}${url}`;
  }
  return url;
}

function normalizeProduct(product) {
  if (!product) return product;
  return { ...product, image: resolveMediaUrl(product.image) };
}

function normalizeGalleryItems(items) {
  return (items ?? []).map((item) => ({
    ...item,
    src: resolveMediaUrl(item.src),
  }));
}

export function normalizeInvitation(data) {
  if (!data) return data;
  return {
    ...data,
    landing: data.landing
      ? { ...data.landing, background: resolveMediaUrl(data.landing.background) }
      : data.landing,
    envelope: data.envelope
      ? { ...data.envelope, seal: resolveMediaUrl(data.envelope.seal) }
      : data.envelope,
    main: data.main
      ? { ...data.main, background: resolveMediaUrl(data.main.background) }
      : data.main,
    gallery: data.gallery
      ? {
          left: normalizeGalleryItems(data.gallery.left),
          right: normalizeGalleryItems(data.gallery.right),
          mobile: normalizeGalleryItems(data.gallery.mobile),
        }
      : data.gallery,
    music: data.music
      ? { ...data.music, src: resolveMediaUrl(data.music.src) }
      : data.music,
  };
}

async function publicFetch(path) {
  const res = await fetch(`${API_BASE}${path}`);
  if (!res.ok) {
    throw new Error(`İstek başarısız (${res.status})`);
  }
  return res.json();
}

export function getCategories(hub) {
  return publicFetch(`/api/categories/${hub}`);
}

export function getProducts(hub, categorySlug) {
  return publicFetch(`/api/products/${hub}/${categorySlug}`).then((items) =>
    items.map(normalizeProduct),
  );
}

export function getProduct(hub, categorySlug, productId) {
  return publicFetch(`/api/products/${hub}/${categorySlug}/${productId}`).then(
    normalizeProduct,
  );
}

export function getSettings() {
  return publicFetch('/api/settings');
}

export function getDigitalInvitations() {
  return publicFetch('/api/digital-invitations');
}

export function getDigitalInvitation(slug) {
  return publicFetch(`/api/digital-invitations/${slug}`).then(normalizeInvitation);
}

export const staticSite = {
  siteName: SITE_NAME,
  getWhatsAppUrl: staticWhatsAppUrl,
};
